import { FileQueueActions } from './fileQueue.actions';

export const fileQueue = {
  namespaced: true,
  actions: {
    ...FileQueueActions,
  },
};

export default fileQueue;
